// Мобильное меню
const mmenu = document.getElementById('mmenu');
const burger = document.getElementById('burger');
if (burger && mmenu) {
  const setOpen = (open) => {
    mmenu.classList.toggle('open', open);
    burger.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  };
  burger.addEventListener('click', () => setOpen(!mmenu.classList.contains('open')));
  const mmclose = document.getElementById('mmclose');
  if (mmclose) mmclose.addEventListener('click', () => setOpen(false));
  mmenu.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setOpen(false)));
}

// Тень шапки при скролле
const hdr = document.getElementById('hdr');
if (hdr) {
  // На главной подложка появляется, когда первая секция (светлые плитки)
  // ушла под шапку; на остальных страницах — почти сразу. Обёртка
  // .shopify-section — display: contents, у неё нет размеров, поэтому
  // берём первый настоящий элемент внутри.
  const first = document.body.classList.contains('template-index') && document.querySelector('main > .shopify-section > *');
  const onScroll = () => {
    const past = first
      ? first.getBoundingClientRect().bottom <= hdr.getBoundingClientRect().bottom
      : window.scrollY > 8;
    hdr.classList.toggle('scrolled', past);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

// Плавное появление карточек
const io = new IntersectionObserver(
  (entries) => {
    for (const e of entries) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    }
  },
  { rootMargin: '0px 0px -8% 0px' }
);
document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

// ── Корзина-попап (Holdings drawer) ──
(function () {
  const SECTION = 'lkc-drawer';
  // токен последнего запроса: ответы устаревших запросов не применяем
  let reqToken = 0;

  function openDrawer() {
    document.body.classList.add('cd-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    document.body.classList.remove('cd-open');
    document.body.style.overflow = '';
  }

  function setCount(n) {
    document.querySelectorAll('.cart-link, .mobile-menu a[href$="/cart"]').forEach((a) => {
      a.textContent = 'Cart (' + n + ')';
    });
  }

  // Вставляет свежий HTML секции дровера и синхронизирует счётчик в шапке
  function applyDrawerHTML(html) {
    const el = document.getElementById('shopify-section-' + SECTION);
    if (!el || !html) return false;
    el.outerHTML = html;
    const title = document.querySelector('#shopify-section-' + SECTION + ' .cd-title');
    const m = title && title.textContent.match(/\((\d+)\)/);
    if (m) setCount(m[1]);
    return true;
  }

  async function refreshDrawer() {
    const token = ++reqToken;
    try {
      const res = await fetch(window.location.pathname + '?sections=' + SECTION, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!res.ok) return;
      const data = await res.json();
      if (token === reqToken) applyDrawerHTML(data[SECTION]);
    } catch (err) { /* сеть упала — оставляем текущее содержимое */ }
  }

  function busy(on) {
    const lines = document.querySelector('.cart-drawer');
    if (lines) lines.classList.toggle('cd-busy', on);
  }

  function changeLine(line, qty) {
    const token = ++reqToken;
    busy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: qty, sections: SECTION }),
    })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('change failed'))))
      .then((cart) => {
        if (token !== reqToken) return;
        if (!(cart.sections && applyDrawerHTML(cart.sections[SECTION]))) return refreshDrawer();
      })
      .catch(() => refreshDrawer())
      .finally(() => busy(false));
  }

  document.addEventListener('click', (e) => {
    const cartLink = e.target.closest('.cart-link, .mobile-menu a[href$="/cart"]');
    if (cartLink) {
      e.preventDefault();
      const mm = document.getElementById('mmenu');
      if (mm) mm.classList.remove('open');
      openDrawer();
      refreshDrawer(); // на случай, если корзина менялась в другой вкладке
      return;
    }
    if (e.target.closest('[data-cd-close]')) { closeDrawer(); return; }
    const rm = e.target.closest('[data-cd-remove]');
    if (rm) changeLine(rm.dataset.line, 0);
  });

  document.addEventListener('change', (e) => {
    const q = e.target.closest('[data-cd-qty]');
    if (q) changeLine(q.dataset.line, Math.max(0, parseInt(q.value, 10) || 0));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  // Добавление в корзину без перезагрузки → открыть попап.
  // Свежий HTML дровера приходит в том же ответе (параметр sections),
  // поэтому между добавлением и отрисовкой нет второго запроса и нет рассинхрона.
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[action*="/cart/add"]');
    if (!f) return;
    e.preventDefault();
    const btn = f.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    const fd = new FormData(f);
    fd.append('sections', SECTION);
    const token = ++reqToken;
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error((data && data.description) || 'add failed');
        if (token === reqToken && !(data.sections && applyDrawerHTML(data.sections[SECTION]))) {
          return refreshDrawer();
        }
      })
      .then(openDrawer)
      .catch(() => f.submit())
      .finally(() => { if (btn) btn.disabled = false; });
  });
})();

// Принудительный запуск hero-видео (страховка от блокировки автоплея)
(function () {
  function kick() {
    document.querySelectorAll('.hero video, .hero-video video, .soon video').forEach(function (v) {
      // если пользователь уже включил звук — не глушим обратно
      if (!v.classList.contains('sound-on')) v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kick);
  else kick();
  window.addEventListener('touchstart', kick, { once: true, passive: true });
  window.addEventListener('click', kick, { once: true });
})();

// Кнопка звука у hero-видео
document.querySelectorAll('[data-hero-sound]').forEach(function (btn) {
  var hero = btn.closest('.hero');
  var v = hero && hero.querySelector('video');
  if (!v) return;
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    var on = v.muted; // сейчас без звука → включаем
    v.muted = !on;
    v.classList.toggle('sound-on', on);
    btn.classList.toggle('on', on);
    btn.setAttribute('aria-pressed', String(on));
    if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  });
});

// Бегущая строка: длительность цикла = ширина одной дорожки / скорость (px/s),
// поэтому текст едет одинаково на любом экране и при любой длине фразы
(function () {
  var ticker = document.querySelector('[data-ticker]');
  var run = ticker && ticker.querySelector('.ticker-run');
  if (!run) return;
  var pxs = Number(ticker.dataset.speed) || 45;
  var fit = function () {
    var w = run.getBoundingClientRect().width;
    if (w > 0) ticker.style.setProperty('--ticker-dur', (w / pxs).toFixed(2) + 's');
  };
  fit();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  if (window.ResizeObserver) new ResizeObserver(fit).observe(run);
})();

// Карусель фото на странице товара
document.querySelectorAll('[data-carousel]').forEach(function (gal) {
  var track = gal.querySelector('.pg-track');
  var slides = track.children;
  var dots = gal.querySelectorAll('.pg-dot');
  var prev = gal.querySelector('.pg-prev');
  var next = gal.querySelector('.pg-next');
  var cur = gal.querySelector('.pg-cur');
  var idx = 0;
  var go = function (i) {
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft });
  };
  var sync = function () {
    var i = Math.round(track.scrollLeft / track.clientWidth);
    if (i === idx) return;
    idx = i;
    dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
    if (cur) cur.textContent = i + 1;
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === slides.length - 1;
  };
  track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
  if (prev) prev.addEventListener('click', function () { go(idx - 1); });
  if (next) next.addEventListener('click', function () { go(idx + 1); });
  dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
  track.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
  });
});
